import PropTypes from "prop-types";
import styles from "./ReceiveType.module.scss";
import config from "../../../config/index";
import { componentResize } from "../../../utils/helperServices";
import Select from "../../atoms/select/Select";
import { useState } from "react";

const ReceiveType = ({
  heading,
  selectedType,
  receiveTypes,
  tabDisable,
  handleReceiveType,
  id,
  className,
}) => {
  const env = config.env;
  const imagePrefix = config.envConfigs[env].imagePrefix;
  const isMobile = componentResize();
  const [selectedValue, setSelectedValue] = useState ("")

  const onRadioChange = (item, index) => {
    if (item.id !== selectedType) {
      handleReceiveType(item.id, index);
    }
  };

  const onDivChange = (item, index) => {
    if (item.id !== selectedType) {
      if (tabDisable && item.id == "store") {
      } else {
        handleReceiveType(item.id, index);
      }
    }
  };


  const onDropdownChange = (val) => {
    let value = "";
    setSelectedValue(val);
    if(val==="Collecting in store"){
      value= "store"
    }
    else {
      value= "courier"
    }
    if (tabDisable && val==="Collecting in store") {
    } else {
      handleReceiveType(value);
    }
  }

  return (
    <>
      {/* { !isMobile && (   */}
      <div className={`${styles["main-container"]} ${className}`} id={id}>
        {heading ? <div className={styles["heading"]}>{heading}</div> : null}

        {/* {selectedType == "courier" && (<div className={styles["radio-buttons-wrapper"]}>
          {receiveTypes.map((item, index) => (
            <div
              className={`${styles["button"]} ${item?.hide ? "d-none" : ""}`}
              key={index}
            >
              <input
                type="radio"
                name="receiveType"
                value={item.label}
                checked={selectedType === item.id}
                onChange={() => onRadioChange(item, index)}
              />
              <label onClick={() => onRadioChange(item, index)}>
                {item.label}
              </label>
            </div>
          ))}
        </div>
        )} */}
        <div className={styles["buttons-wrapper"]}>
          {receiveTypes.map((item, index) => (
            <div
              onClick={() => onDivChange(item, index)}
              className={`${!isMobile ? styles["button"] : styles["mobile-view-tab"]} ${styles[selectedType === item.id ? "checkedButton" : ""]} ${styles[tabDisable && item.id == "store" ? "disableTab" : ""]}  ${item?.hide ? "d-none" : ""}`}
              key={index}
            >
              <div
                value={item.label}
                checked={selectedType === item.id}
                onChange={() => onDivChange(item, index)}
                className={styles["buttons-wrapper__container"]}
              >
                <img
              className={styles["delivery-icon"]}
              src={`${imagePrefix}/assets/images/${item.img}`}
            />
              <label
              className={`${styles[selectedType === item.id ? "checkedDiv" : ""]}`}
              >
                {!isMobile ? item.label : item.id == "store" ? "Collection" : "Delivery"}
              </label>
              </div>
            </div>
          ))}
        </div>
        {/* )} */}
      </div>
      {/* )} */}
      {/* { isMobile && (  
       <div className={`${styles["main-container"]} ${className}`} id={id}>
     <Select
                    optionsList={receiveTypes}
                    handleOptionClick={onDropdownChange}
                    selectedValue={selectedValue}
                    className={styles["dropDown"]}
                  />
                  </div>
     )} */}
    </>
  );
};

ReceiveType.propTypes = {
  heading: PropTypes.string,
  selectedType: PropTypes.string,
  receiveTypes: PropTypes.array,
  handleReceiveType: PropTypes.func,
  id: PropTypes.string,
  className: PropTypes.string,
};

ReceiveType.defaultProps = {
  heading: null,
  receiveTypes: [],
  id: "receive-type",
};

export default ReceiveType;
